import React, { useState } from "react";
import { Images } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import MemberPhotoAlbum from "@/components/MemberPhotoAlbum";
import Albums from "@/pages/Albums";
import { t } from "@/lib/i18n";

export default function MemberAlbums({ photos, memberName, memberId }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  if (!user || user.role === "guest") return <MemberPhotoAlbum photos={photos} memberName={memberName} memberId={memberId} />;
  return <section className="mt-4">
    <Button variant="outline" size="sm" onClick={() => setOpen(true)} data-testid="view-album-button"><Images size={16} className="mr-2" />{t("View Album")}</Button>
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-6xl max-h-[90dvh] overflow-y-auto bg-[#FBF8F1]">
        <DialogHeader><DialogTitle>{t("{0}'s photo album", { 0: memberName })}</DialogTitle><DialogDescription>{t("View member photos and your private albums.")}</DialogDescription></DialogHeader>
        {open && <Albums embedded defaultPhotos={photos} memberName={memberName} memberId={memberId} />}
      </DialogContent>
    </Dialog>
  </section>;
}
